export const GET_FIXTURES_BY_SPORT_ID = "GET_FIXTURES_BY_SPORT_ID";
export const GET_FIXTURES_BY_SPORT_ID_RESPONSE_SUCCESS =
  "GET_FIXTURES_BY_SPORT_ID_RESPONSE_SUCCESS";
